import React from 'react';
import PropTypes from 'prop-types';

import { TweenLite, Back, Power1 } from 'gsap/all';
import { Transition } from 'react-transition-group';


const D3SampleCartTransition = (props) => {
	const {
		timeout,
		active,
		callbacks,
		children,
		delay,
	} = props;

	const animationTimeout = timeout / 1000;
	const animationDelay = delay * 0.3;
	const activeAnimationTimeout = active ? animationTimeout : animationTimeout / 2;

	const onEnter = (node, isAppearing) => {
		// console.log('[On Enter]', node, ' :: ', isAppearing);
	};

	const onEntering = (node, isAppearing) => {
		// console.log('[On Entering]', node, ' :: ', isAppearing);
	};

	const onEntered = (node, isAppearing) => {
		// console.log('[On Entered]', node, ' :: ', isAppearing);
	};

	const onExit = (node) => {
		node.style.zIndex = '2';
		// console.log('[On Exit]', node);
	};

	const onExiting = (node) => {
		// console.log('[On Exiting]', node);
	};

	const onExited = (node) => {
		// console.log('[On Exited]', node);
		callbacks.checkEmptyCart();
	};

	const onEnd = (node, done) => {
		// console.log('[On End]', node, done);
		const distance = active ? 80 : 100;
		const { height } = node.getBoundingClientRect();
		TweenLite.fromTo(
			node,
			activeAnimationTimeout,
			{
				xPercent: active ? distance : 0,
				autoAlpha: active ? 0 : 1,
				height: active ? 0 : height,
			},
			{
				xPercent: active ? 0 : distance,
				autoAlpha: active ? 1 : 0,
				height: active ? height : 0,
				ease: Power1.easeInOut,
				onComplete: active ? () => { callbacks.resetHeight(node); } : done,
			},
		).delay(active ? animationDelay : 0);
	};

	return (
		<Transition
			timeout={timeout}
			mountOnEnter
			unmountOnExit
			appear={false}
			in={active}
			onEnter={onEnter}
			onEntering={onEntering}
			onEntered={onEntered}
			onExit={onExit}
			onExiting={onExiting}
			onExited={onExited}
			addEndListener={onEnd}
		>
			{ children }
		</Transition>
	);
};

D3SampleCartTransition.propTypes = {
	timeout: PropTypes.number.isRequired,
	active: PropTypes.bool,
	callbacks: PropTypes.shape({}),
	children: PropTypes.shape({}),
	delay: PropTypes.number,
};

D3SampleCartTransition.defaultProps = {
	active: true,
	callbacks: {},
	children: {},
	delay: 0,
};

export default D3SampleCartTransition;
